import {
  CdkDrag,
  CdkDragDrop,
  CdkDropList,
  moveItemInArray,
  transferArrayItem
} from '@angular/cdk/drag-drop';
import {
  Component,
  DoCheck,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { IMultiSelectItem } from '@app/ui/option-multi-select/multi-select-item.interface';
import { Setting } from '@app/reports/report-settings/setting.model';
import { getIdentifierForIterableItem } from '@app/shared/utilities/trackby.utility';
import { MatLegacyInputModule } from '@angular/material/legacy-input';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { NgForOf, NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatListModule } from '@angular/material/list';

const DRAG_DROP_THRESHOLD = 10;

@Component({
  selector: 'acs-option-multi-select',
  templateUrl: './option-multi-select.component.html',
  styleUrls: ['./option-multi-select.component.scss'],
  imports: [
    MatLegacyInputModule,
    MatLegacyButtonModule,
    MatIconModule,
    NgIf,
    FormsModule,
    NgForOf,
    CdkDropList,
    CdkDrag,
    MatLegacyCheckboxModule,
    MatListModule
  ],
  standalone: true
})
export class OptionMultiSelectComponent implements OnInit, OnChanges, DoCheck {
  // here
  @Input() setting: Setting;
  @Input() inModal: boolean;
  @Input() showAddButton: boolean;
  @Input() singleColumn: boolean;
  @Output() itemMovedEvent = new EventEmitter();
  @Output() itemAddEvent = new EventEmitter<string>();

  public available: IMultiSelectItem[] = [];
  public selected: IMultiSelectItem[] = [];
  public searchText = '';
  public jumpFocus: string;
  public getIdentifierForIterableItem = getIdentifierForIterableItem;

  constructor() {}

  ngOnInit(): void {
    this.updateLists();
    this.jumpFocus = 'searchText';
  }

  ngDoCheck(): void {
    if (
      JSON.stringify(this.setting.options.filter((x) => x.selected)) !==
      JSON.stringify(this.selected)
    ) {
      this.filterList();
    }
  }

  ngOnChanges(onChangesObj: SimpleChanges): void {
    if (onChangesObj.setting.currentValue !== onChangesObj.setting.previousValue) {
      this.updateLists();
    }
  }

  public drop(event: CdkDragDrop<string[]>): void {
    if (event.previousContainer === event.container) {
      moveItemInArray(event.container.data, event.previousIndex, event.currentIndex);
    } else {
      transferArrayItem(
        event.previousContainer.data,
        event.container.data,
        event.previousIndex,
        event.currentIndex
      );

      this.available.forEach((x) => (x.selected = false));
      this.selected.forEach((x) => (x.selected = true));
      this.itemMovedEvent.emit();
    }
  }

  public updateLists(): void {
    this.available = this.setting.options.filter((x) => !x.selected);
    this.selected = this.setting.options.filter((x) => x.selected);
  }

  public addOption(): void {
    this.itemAddEvent.emit(this.searchText);
  }

  public selectAll(): void {
    this.inModal
      ? this.setting.options.map((option: any) => (option.selected = true))
      : this.setting.selectAll();
  }

  public unselectAll(): void {
    this.inModal
      ? this.setting.options.map((option: any) => (option.selected = false))
      : this.setting.unselectAll();
  }

  public filterList(): void {
    this.updateLists();

    if (this.searchText.length > 0) {
      this.available = this.setting.options.filter(
        (x) => !x.selected && x.name.toLowerCase().includes(this.searchText.toLowerCase())
      );
    }
    this.itemMovedEvent.emit(this.selected);
  }

  public showDragDropSection(): boolean {
    return this.setting.options.length > DRAG_DROP_THRESHOLD || this.setting.showDragDrop;
  }

  public clearInput(): void {
    this.searchText = '';
    this.updateLists();
  }

  public selectOption(): void {
    const matchingOption = this.setting.options.find(
      (x) => x.name.toLowerCase() === this.searchText.toLowerCase()
    );
    const filteredResult = this.setting.options.filter((x) =>
      x.name.toLowerCase().includes(this.searchText.toLowerCase())
    );

    if (matchingOption) {
      matchingOption.selected = !matchingOption.selected;
      this.searchText = '';
    } else if (filteredResult.length === 1) {
      filteredResult[0].selected = !filteredResult[0].selected;
      this.searchText = '';
    }

    this.updateLists();
  }
}
